import {
  EGlobalTransactionOrderBy,
  GlobalTransaction
} from '@/modules/common/services/graphql/server/server.sdk';

export enum SortingOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

interface BaseColumn {
  key?: EGlobalTransactionOrderBy;
  sortingOrder?: SortingOrder;
  isSorting?: boolean;
  class?: string;
  width?: string;
}

interface Column {
  title: string;
  component?: never;
  props?: never;
}

interface ColumnComponent {
  title?: never;
  component: string;
  props: Record<string, any>;
}

export type TableColumn = BaseColumn & (Column | ColumnComponent);

export interface TransactionRow extends GlobalTransaction {
  hasDetails: boolean;
  parsedDate: { date: string; time: string };
  isCanceled: boolean;
}

export interface TransactionFilters {
  portfolioId?: string;
  datePeriod?: string;
  movementType?: string;
}

export interface TransactionFiltersOption {
  key: string;
  description: string;
}

export interface TransactionFiltersOptions {
  portfolios: TransactionFiltersOption[];
  datePeriods: TransactionFiltersOption[];
  movementTypes: TransactionFiltersOption[];
}

export interface FilterSelectOption {
  label: string;
  value: string;
}
